import { useRecoilValue } from 'recoil';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { ProductSkeleton } from '../../components/ProductSkeleton';
import { ProductBody } from '../../components/ProductBody';
import { ProductHeader } from '../../components/ProductHeader';
import { useSelectProduct } from '../../hooks/api';
import { percomaticLoadedState } from '../../../atoms';
import { useProductImageQuery } from '../../graphql';

import styled from 'styled-components';
import { useAppSelector } from '../../../reduxstore/hooks';

export const Product: React.FC = () => {
	const params = useParams();
	const { data } = useProductImageQuery({
		variables: { productId: params?.id ? params.id : '' }
	});
	const loaded = useRecoilValue(percomaticLoadedState);
	const [productId, setProductId] = useState<number>(Number(params.id));
	const unavailableProducts = useAppSelector(
		state => state.uiReducer.unavailableProductIds
	);

	const [available, setAvailable] = useState(true);

	const selectProduct = useSelectProduct();

	useEffect(() => {
		const newId = Number(params.id);

		if (unavailableProducts.find(el => el === newId)) {
			setAvailable(false);
			return;
		}

		if (!isNaN(newId) && newId !== productId) {
			setProductId(newId);
		}
	}, [params.id, productId, unavailableProducts]);

	useEffect(() => {
		if (!isNaN(productId) && loaded) {
			selectProduct(productId);
		}
	}, [productId, selectProduct, loaded]);

	return (
		<Container>
			{available ? (
				<>
					{loaded ? (
						<>
							<Content>
								<ProductHeader />
							</Content>
							<Content>
								<ProductBody
									autoModify={data?.product?.autoModify}
								/>
							</Content>
						</>
					) : (
						<ProductSkeleton />
					)}
				</>
			) : (
				<>
					<p>
						This product is not available at this store! Please
						select a different store or product.
					</p>
				</>
			)}
		</Container>
	);
};

const Container = styled.div`
	max-width: 1140px;
	width: 100%;
	display: flex;
	flex-direction: row;
	column-gap: 24px;

	@media (max-width: 768px) {
		flex-direction: column;
		row-gap: 24px;
		column-gap: unset;
	}
`;

const Content = styled.div`
	width: 50%;

	@media (max-width: 768px) {
		width: 100%;
	}
`;
